module.exports = __webpack_public_path__ + "img/3.2af0facf.jpg";